import { AlertCircle } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgExclamationOutline = mkIcon(AlertCircle);